export const prefix = 'rfy:';
export var FieldNames;
(function (FieldNames) {
    FieldNames["optimizationObjective"] = "rfy:optimizationObjective";
})(FieldNames || (FieldNames = {}));
export var BusinessObjectiveOptions;
(function (BusinessObjectiveOptions) {
    BusinessObjectiveOptions["ClickThroughRate"] = "ctr";
    BusinessObjectiveOptions["ConversionRate"] = "cvr";
    BusinessObjectiveOptions["RevenuePerOrder"] = "revenue-per-order";
})(BusinessObjectiveOptions || (BusinessObjectiveOptions = {}));
export const defaultFormValues = {
    [FieldNames.optimizationObjective]: BusinessObjectiveOptions.ClickThroughRate,
};
export const labelByFieldOption = {
    [BusinessObjectiveOptions.ClickThroughRate]: 'RECS_MODEL_BUSINESS_OBJECTIVE_CLICK_THROUGH_RATE',
    [BusinessObjectiveOptions.ConversionRate]: 'RECS_MODEL_BUSINESS_OBJECTIVE_CONVERSION_RATE',
};
